import React from 'react';
import { useTranslation } from 'react-i18next';
import './DescubreAntarie.css';

const DescubreAntarie = () => {
  const { t } = useTranslation('common');

  return (
    <section>

      <header className="cajeadoHorizontal margenInferiorBigMedBig">
        <h2 className="textoAzul fontBold fontH1 textoCentrado">{t('link.descubreAntarie')}</h2>
        <hr className="separacion" />
        <p className="textoCentradoJustificado">{t('textos.descubreAntarie')}</p>
      </header>

      <div className="contenedor margenlateraldescubre margenInferiorBig">
        <div className="col-pxxxl-16 col-pxxl-1 col-pxl-1 col-pl-1 hidden-pm hidden-ps hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs">&nbsp;</div>

        <a className="col-pxxxl-3 col-pxxl-5 col-pxl-3 col-pl-3 col-pm-6 col-ps-6 col-pxs-8 col-pxxs-8 col-xxl-6 col-xl-6 col-l-6 col-m-12 col-s-12 col-xs-12 col-xxs-12 textoCentrado margenInterCaja margenInterCajaS margenInterCajaM" href={process.env.REACT_APP_URL_SOLUCIONES_SOFTWARE}>
          <div className="ca ca_pr ca_pr_0">
            <i className="fas fa-server margenInferiorMed" />
            <h2 className="fontDescubre textoAzul fontBold">{t('link.solucionesSoftware')}</h2>
          </div>
        </a>

        <a className="col-pxxxl-3 col-pxxl-5 col-pxl-3 col-pl-3 col-pm-4 col-ps-4 col-pxs-8 col-pxxs-8 col-xxl-6 col-xl-6 col-l-6 col-m-12 col-s-12 col-xs-12 col-xxs-12 textoCentrado margenInterCaja margenInterCajaS margenInterCajaM" href={process.env.REACT_APP_URL_DESARROLLO_WEB}>
          <div className="ca ca_pr ca_pr_240">
            <i className="fas fa-drafting-compass margenInferiorMed" />
            <h2 className="fontDescubre textoAzul fontBold">{t('link.desarrolloWeb')}</h2>
          </div>
        </a>

        <a className="col-pxxxl-3 col-pxxl-5 col-pxl-3 col-pl-3 col-pm-6 col-ps-6 col-pxs-8 col-pxxs-8 col-xxl-6 col-xl-6 col-l-6 col-m-12 col-s-12 col-xs-12 col-xxs-12 textoCentrado margenInterCaja margenInterCajaS margenInterCajaM" href={process.env.REACT_APP_URL_DESARROLLO_APPS}>
          <div className="ca ca_pr ca_pr_180">
            <i className="fas fa-mobile-alt margenInferiorMed" />
            <h2 className="fontDescubre textoAzul fontBold">{t('link.desarrolloApps')}</h2>
          </div>
        </a>

        <a className="col-pxxxl-3 col-pxxl-5 col-pxl-3 col-pl-3 col-pm-6 col-ps-6 col-pxs-8 col-pxxs-8 col-xxl-6 col-xl-6 col-l-6 col-m-12 col-s-12 col-xs-12 col-xxs-12 textoCentrado margenInterCaja margenInterCajaS" href={process.env.REACT_APP_URL_MACHINE_LEARNING}>
          <div className="ca ca_pr ca_pr_60">
            <i className="fas fa-cogs margenInferiorMed" />
            <h2 className="fontDescubre textoAzul fontBold">{t('link.aiMachineLearning')}</h2>
          </div>
        </a>

        <a className="col-pxxxl-3 col-pxxl-5 col-pxl-3 col-pl-3 col-pm-4 col-ps-4 col-pxs-8 col-pxxs-8 col-xxl-6 col-xl-6 col-l-6 col-m-12 col-s-12 col-xs-12 col-xxs-12 textoCentrado margenInterCaja" href={process.env.REACT_APP_URL_TRANSFORMACION_DIGITAL}>
          <div className="ca ca_pr ca_pr_120">
            <i className="fas fa-laptop margenInferiorMed" />
            <h2 className="fontDescubre textoAzul fontBold">{t('link.transformacionDigital')}</h2>
          </div>
        </a>

        <a className="col-pxxxl-3 col-pxxl-5 col-pxl-3 col-pl-3 col-pm-6 col-ps-6 col-pxs-8 col-pxxs-8 col-xxl-6 col-xl-6 col-l-6 col-m-12 col-s-12 col-xs-12 col-xxs-12 textoCentrado" href={process.env.REACT_APP_URL_MIGRACION_NUBE}>
          <div className="ca ca_pr ca_pr_0">
            <i className="fas fa-cloud-upload-alt margenInferiorMed" />
            <h2 className="fontDescubre textoAzul fontBold">{t('link.migracionNube')}</h2>
          </div>
        </a>

        <div className="col-pxxxl-16 col-pxxl-1 col-pxl-1 col-pl-1 hidden-pm hidden-ps hidden-pxs hidden-pxxs hidden-xxl hidden-xl hidden-l hidden-m hidden-s hidden-xs hidden-xxs">&nbsp;</div>
      </div>

      <div className="contenedor cajeadoHorizontal">
        <p className="col-pxxxl-50 col-pxxl-32 col-pxl-20 col-pl-20 col-pm-16 col-ps-16 col-pxs-16 col-pxxs-16 col-xxl-12 col-xl-12 col-l-12 col-m-12 col-s-12 col-xs-12 col-xxs-12 textoCentradoJustificado margenInferiorBig coalign">{t('textos.descubreAntariePie')}</p>
        <p className="col-pxxxl-50 col-pxxl-32 col-pxl-20 col-pl-20 col-pm-16 col-ps-16 col-pxs-16 col-pxxs-16 col-xxl-12 col-xl-12 col-l-12 col-m-12 col-s-12 col-xs-12 col-xxs-12 textoCentrado textoAzul fontDescubrePie fontBold">
          <i className="fas fa-envelope" style={{ marginRight: '10px' }} />{t('contacto.email')}
        </p>
        <p className="col-pxxxl-50 col-pxxl-32 col-pxl-20 col-pl-20 col-pm-16 col-ps-16 col-pxs-16 col-pxxs-16 col-xxl-12 col-xl-12 col-l-12 col-m-12 col-s-12 col-xs-12 col-xxs-12 textoCentrado textoAzul fontDescubrePie fontBold">
          <i className="fas fa-phone" style={{ verticalAlign: '1px', marginRight: '10px' }} />{t('contacto.telefono')}
        </p>
      </div>

    </section>
  );
};

export default DescubreAntarie;
